export function editUrl(WS_URL) {
  const hostname = window.location.hostname
  if (hostname === 'localhost') {
    WS_URL = 'wss://dev.orbitalgaming.io/wsbridge/v1/game/orbital.astro'
  } else if (WS_URL === "{{SERVER_WS_URL}}") {
    WS_URL = `wss://${hostname}/wsbridge/v1/game/orbital.astro`
  }
  return WS_URL
}
